import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { screen } from 'legacy/styles/screen'

export const Content = styled.div`
  align-items: center;
  color: ${getToken('color-neutral-dark')};
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  justify-content: center;
  padding: 16px;
  text-align: center;
  width: 100%;
  & > :not(:last-child) {
    margin-bottom: 20px;
  }

  ${screen.md} {
    min-height: 380px;
    padding: 32px;
    width: 340px;
  }
`

export const Message = styled.div`
  font-size: ${getToken('font-family-default')};
  padding-bottom: 10px;
  line-height: 22px;

  p {
    margin-bottom: ${getToken('space-xs')};
  }
`
